import Team from '../Team.jsx';

/**
 * Thin wrapper so the Team page lives under /account/team in the
 * sidebar layout without forking the implementation. The Team page
 * itself still works as-is — we just removed the inline page-level
 * back-link/header that was specific to its old standalone URL.
 */
export default function TeamWrapper() {
  return <Team embedded />;
}
